<template lang="pug">
  div.restaurants__selection
    template(v-if="currentPos")
      span.restaurants__option-selected
        span {{currentPos.Pos_Name}}
      span.distance {{ currentPos.Distance }}km
    span.restaurants__option-selected(v-else)
    button(@click.prevent="showDropdown")
      icon-caret
    div.restaurants__dropdown(ref="restaurants__dropdown", :class="{'is-open' : isDropdownShow}")
      perfect-scrollbar
        HeaderPosList(:posData="posList" , :location="location" @change="onChangePos")

    div.modal-confirm(v-if="isPopupShow")
      h3.modal-confirm__title &nbsp;
      p.modal-confirm__content Bạn muốn tiếp tục đổi cơ sở đặt hàng không?
      div.modal-confirm__actions
        a.modal-confirm__ok(@click.prevent="cancel") Không đổi cơ sở nữa
        a.modal-confirm__cancel(@click.prevent="doIt") Tiếp tục
</template>
<script>
  import {mapState, mapGetters ,mapActions} from 'vuex'
  import { bus } from '../main'
  import IconCaret from "./icons/IconCaret";

  import HeaderPosList from "./HeaderPosList"

  export default {
    name: 'Restaurants',
    components: {
      IconCaret,
      HeaderPosList
    },
    computed: {
      ...mapGetters('restaurants', [
        'currentRestaurantPos',
      ]),
      ...mapState({
        selected: state => state.restaurants.selected,
        restaurants: state => state.restaurants.all,
        location: state => state.shipments.location,
      }),
      posList() {
        return this.restaurants.map(item => item.pos)
      },
      currentPos() {
        if (this.currentRestaurantPos && this.currentRestaurantPos.pos) {
          let dist = this.currentRestaurantPos.pos
          if (this.location) {
            const p1 = {
              lng: dist.Pos_Longitude,
              lat: dist.Pos_Latitude,
            };
            const p2 = this.location;
            dist.Distance = this.distance(p1, p2);
          }
          return dist ? dist : null;
        }
      },
    },
    data() {
      return {
        tmpPos: null,
        isDropdownShow: false,
        isPopupShow: false,
        dist: null
      }
    },
    methods: {
      showDropdown() {
        this.addOverlay();
        this.isDropdownShow = true
        this.isPopupShow = false
      },
      hideDropdown() {
        this.isDropdownShow = false
        this.isPopupShow = true
      },
      doIt() {
        // gọi hàm store
        this.$store.dispatch('restaurants/setSelected', this.tmpPos.Id);
        //this.$store.dispatch('cart/removeCart', null );
        //bus.$emit('removeCart');

        this.isPopupShow = false
        this.isDropdownShow = false
        this.tmpPos = null
        this.removeOverlay()
      },
      cancel() {
        this.isPopupShow = false
        this.isDropdownShow = false
        this.tmpPos = null
        this.removeOverlay()
      },
      addOverlay: () => document.getElementById('menuComponent').classList.add('has-overlay'),
      removeOverlay: () => document.getElementById('menuComponent').classList.remove('has-overlay'),
      onChangePos(pos) {
        this.tmpPos = pos
        this.hideDropdown();
      },
      select(id, type = 'delivery') {
        this.$store.dispatch('shipments/setSelected', id)
        if ('pickup' === type) this.getUserLocation();
      },
      async getUserLocation() {
        let loc = await this.$getLocation().then(({lat, lng}) => ({lat, lng}));
        if (loc) this.$store.dispatch('shipments/setLocation', loc)

      },
      distance(p1, p2) {
        const rad = (x) => (x * Math.PI / 180)
        const R = 6378137; // Earth’s mean radius in meter
        const dLat = rad(p2.lat - p1.lat);
        const dLong = rad(p2.lng - p1.lng);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) *
          Math.sin(dLong / 2) * Math.sin(dLong / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c / 1000;
        return d > 0 ? parseFloat(d.toFixed(2)) : null

      },
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Restaurants.vue